import store from "../redux/store"
import { LEGAL_COMPLIANCE_ADMIN_TYPE, SUB_ADMIN_TYPES } from "assets/constants";

const createUtils = () => {

    const _img = (name = '') => `${process.env.PUBLIC_URL}/assets/images/${name}`;
    const isPasswordMatch = (password1, password2) => password1 === password2
    const checkAdminType = () => store.getState()?.['admin']?.['adminUser']?.['type']
    const getAdminHomeRoute = (type = checkAdminType()) => {
        if (type === "owner") return "/admin/dashboard";
        if (SUB_ADMIN_TYPES.includes(type)) return "/sub-admin/dashboard";
        if (type === LEGAL_COMPLIANCE_ADMIN_TYPE) return "/admin/legal-compliance";
        return "/admin-login";
    };
    const hasLanguageInPathname = (pathname = '', languages = []) => languages.includes(pathname.split("/")?.[1]);
    const createObjectURL = (file) => file ? URL.createObjectURL(file) : "";
    const serverImg = (name) => `${process.env.REACT_APP_SERVER_URL}/upload/${name}`

    return {isPasswordMatch, _img, checkAdminType, getAdminHomeRoute, hasLanguageInPathname,createObjectURL,serverImg}
};


const utils = createUtils();

export default utils;
